import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  //BPBottlerSelection REDUX part
  BPbottlerData: [],
  BPtransformedTreeData: [],
  BPselectedTreeIds: [],
  BPfinalTreeData: [],
  BPfilterApplied: false,
};

const BPEntityTree = createSlice({
  name: "BPentity",
  initialState,
  reducers: {
    setBPBottlerData: (state, action) => {
      state.BPbottlerData = action.payload;
    },
    setBPTransformedTreeData: (state, action) => {
      state.BPtransformedTreeData = action.payload;
    },
    setBPSelectedTreeIds: (state, action) => {
      state.BPselectedTreeIds = action.payload;
    },
    setBPFinalTreeData: (state, action) => {
      state.BPfinalTreeData = action.payload;
    },
    setBPFilterApplied: (state, action) => {
      state.BPfilterApplied = action.payload;
    },
  },
});

export const {
  setBPBottlerData,
  setBPTransformedTreeData,
  setBPSelectedTreeIds,
  setBPFinalTreeData,
  setBPFilterApplied,
} = BPEntityTree.actions;
export default BPEntityTree.reducer;
